/** Custom vue directive for multi clicks
Usage:

1. Add the `v-multiclick` attribute to your component
2. Listen for @single-click and @multi-click events
3. Optionally set the timeout as a value for the `v-multiclick` attribute like so: `v-multiclick="300"`

*/
export default {
  bind(el, binding, vnode) {
    binding.$_waitDoubleClick = false;
    binding.$_clickTimeout = null;
    binding.$_timeout = binding.value || 300; // ms

    binding.$_emit = (eventName) => {
      if (vnode.child) {
        vnode.child.$emit(eventName);
      } else {
        el.dispatchEvent(new Event(eventName));
      }
    };

    binding.$_clearTimerTimeout = () => {
      if (binding.$_clickTimeout) {
        window.clearTimeout(binding.$_clickTimeout);
      }
    };
    el.onmousedown = (evt) => {
      evt.preventDefault();
      return false;
    };
    el.onclick = (evt) => {
      if (binding.$_waitDoubleClick) {
        binding.$_waitDoubleClick = false;
        binding.$_clearTimerTimeout();
        binding.$_emit('double-click');
        // vnode.child.$emit('double-click');
        return;
      }
      // Set double click timer
      binding.$_waitDoubleClick = true;
      binding.$_clickTimeout = window.setTimeout(() => {
        binding.$_emit('single-click');
        // vnode.child.$emit('single-click');
        binding.$_waitDoubleClick = false;
        binding.$_clearTimerTimeout();
      }, binding.$_timeout);
    };
  },
};
